import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { capitalize } from 'lodash';

import Speaker from '../../Speakers/components/Speaker';
import './TalkInformation.css';

export class TalkInformation extends React.PureComponent {
    onSpeakerClick = speakerId => () => this.props.onSpeakerClickHandler(speakerId);

    render() {
        const {
            id,
            title,
            proficiency,
            liveCoding,
            summary,
            speakers,
            speakersTitle,
            talkType,
            technicalOrBusiness,
            video,
            location,
            track
        } = this.props;
        const styles = speakers.length === 0 ? { paddingBottom: '50px' } : null;
        const feedbackBtn =
            track === 'Hands-on Lab' ? (
                <a
                    className="button is-large"
                    href={`${window.location.pathname}#${location.pathname}/ff`}
                    id="blue-button"
                    rel="noopener noreferrer"
                    style={{ marginTop: '50px' }}
                >
                    FEEDBACK FORM
                </a>
            ) : null;

        return (
            <div
                className="column is-four-fifths is-10-mobile is-offset-1-mobile talk-detail"
                key={id}
                style={styles}
            >
                <div className="underline">
                    <div className="columns is-multiline">
                        <h4 className="column is-7-desktop is-full-touch title talk-title">
                            {title}
                        </h4>
                        <div className="column is-hidden-touch" />
                        <h4 className="column talk-difficulty is-narrow title talk-title">
                            <span className={`${video ? 'video' : 'is-hidden'}`}>
                                <a
                                    href={video}
                                    id="video-link"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <i className="fab fa-youtube-square" id="video-link" /> Talk
                                    video
                                </a>
                            </span>
                            <span className={`${!technicalOrBusiness ? 'is-hidden' : ''}`}>
                                {capitalize(technicalOrBusiness)} Talk
                            </span>
                            <span className={`${!proficiency ? 'is-hidden' : ''}`}>
                                Proficiency: {capitalize(proficiency)}
                            </span>
                            <span className={`${!talkType ? 'is-hidden' : ''}`}>
                                Talk Level: {capitalize(talkType)}
                            </span>
                            <span className={`${liveCoding ? '' : 'is-hidden'}`}>
                                Includes Livecoding
                            </span>
                        </h4>
                    </div>
                    <p className="description">{summary}</p>
                    {feedbackBtn}
                </div>
                {speakers.length > 0 ? (
                    <div className="speakers-part">
                        <h4 className="title talk-title">{speakersTitle}</h4>
                        <div className="columns is-multiline">
                            {speakers &&
                                speakers.map((speaker, i) => {
                                    const speakerObj =
                                        typeof speaker === 'object'
                                            ? { ...speaker, onClick: this.onSpeakerClick }
                                            : { id: `unknown${i}`, name: speaker };
                                    return (
                                        <Speaker
                                            company={speakerObj.company || ''}
                                            id={speakerObj.id}
                                            key={speakerObj.id}
                                            name={speakerObj.name || ''}
                                            onSpeakerClick={speakerObj.onClick}
                                            shortDesc={speakerObj.shortDesc || ''}
                                        />
                                    );
                                })}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

TalkInformation.defaultProps = {
    speakersTitle: 'Speakers'
};

TalkInformation.propTypes = {
    id: PropTypes.string.isRequired,
    liveCoding: PropTypes.bool.isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    onSpeakerClickHandler: PropTypes.func.isRequired,
    proficiency: PropTypes.string.isRequired,
    speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
    speakersTitle: PropTypes.string,
    summary: PropTypes.string.isRequired,
    talkType: PropTypes.string.isRequired,
    technicalOrBusiness: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    track: PropTypes.string.isRequired,
    video: PropTypes.string.isRequired
};

export default withRouter(TalkInformation);
